// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rYwGL","heading":"styles_heading__asIJL","sec_text":"styles_sec_text__unFvJ","videos_container":"styles_videos_container__iMlgb"};